import { InventoryRouteGroup } from '@root/globalTypes';

export const canScheduleRoute = (points: InventoryRouteGroup[] = []) => {
  const allPoints = points.flat();
  return allPoints.some((el) => el.scheduled) && !allPoints.some((el) => el.hidden);
};
